import React, { useEffect, useState } from "react"
import { Col, Container, Row } from "reactstrap"
import EventsCard from "components/Common/EventsCard"

const PastEventList = () => {
  const [events, setEvents] = useState([])
  useEffect(() => {
    async function fetchPastEvents() {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/dashboard/get-events-list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ filter: "active-past" }), // Add if your API expects a body
          }
        )
        const data = await response.json()
        setEvents(data.events || [])
      } catch (err) {
        setEvents([])
      }
    }
    fetchPastEvents()
  }, [])

  return (
    <div className="wrapper-padd bg-lgpink">
      <Container>
        <Row>
          <h1 className="mainTitle">Past Events</h1>
        </Row>
        <Row className="g-4">
          {events.length === 0 && (
            <Col>
              <p>No past events found.</p>
            </Col>
          )}
          {events.map(event => (
            <Col sm={12} md={6} lg={4} xl={4} key={event.id}>
              <EventsCard
                url={`${process.env.REACT_APP_API_URL.replace(
                  "/api",
                  ""
                )}/storage/${event.banner}`} // url={`${process.env.REACT_APP_API_URL.replace('/api', '')}/storage${event.banner}`}
                mainTitle={event.title}
                subTitle={event.category_name}
                dateTime={
                  event.first_schedule_date && event.first_schedule_start
                    ? `${event.first_schedule_date} ${event.first_schedule_start} Onward`
                    : event.first_schedule_date || ""
                }
                cardClassName="pastevent-cursor"
              />
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default PastEventList
